import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { useSignaturesDistributionContext } from '../../shared/provider';

export const Loaders: React.FC = () => {
	const {
		data: { isLoadingData, isCrunchingData },
	} = useSignaturesDistributionContext();

	return (
		<>
			{isLoadingData && <Loader data-testid="loading-data" size="m" my={256} mx="auto" />}
			{isCrunchingData && <Loader data-testid="crunching-data" size="m" my={256} mx="auto" />}
		</>
	);
};
